module.exports = __webpack_public_path__ + "img/loading1.8ad7d0eb.png";